import { render, staticRenderFns } from "./Pie.md?vue&type=template&id=7f675460&"
import script from "./Pie.md?vue&type=script&lang=js&"
export * from "./Pie.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f675460')) {
      api.createRecord('7f675460', component.options)
    } else {
      api.reload('7f675460', component.options)
    }
    module.hot.accept("./Pie.md?vue&type=template&id=7f675460&", function () {
      api.rerender('7f675460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/Pie.md"
export default component.exports